import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _HeaderMenuButton;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { IconHamburgerLine } from '@instructure/ui-icons';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { jsx } from '@instructure/emotion';
import t from '@instructure/quiz-i18n/es/format-message';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { withStyleOverrides } from '@instructure/quiz-common';
export var HeaderMenuButton = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_HeaderMenuButton = /*#__PURE__*/function (_Component) {
  function HeaderMenuButton() {
    var _this;
    _classCallCheck(this, HeaderMenuButton);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, HeaderMenuButton, [].concat(args));
    _defineProperty(_this, "toggleNavigator", function () {
      var msg = _this.props.sidebarOpen ? t('Closed Question Navigator Menu') : t('Opened Question Navigator Menu');
      _this.props.screenreaderNotification(msg);
      _this.props.sidebarMenuClick();
    }.bind(_this));
    return _this;
  }
  _inherits(HeaderMenuButton, _Component);
  return _createClass(HeaderMenuButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        hidden = _this$props.hidden,
        sidebarOpen = _this$props.sidebarOpen;
      if (hidden) {
        return null;
      }
      return jsx("div", {
        css: this.props.styles.title
      }, jsx("button", {
        css: this.props.styles.menuButton,
        onClick: this.toggleNavigator,
        tabIndex: "0",
        "data-automation": "sdk-hamburger-button"
      }, jsx(IconHamburgerLine, null), jsx(ScreenReaderContent, null, sidebarOpen ? t('Hide Question Navigator Menu') : t('Show Question Navigator Menu'))));
    }
  }]);
}(Component), _defineProperty(_HeaderMenuButton, "displayName", 'HeaderMenuButton'), _defineProperty(_HeaderMenuButton, "componentId", "Quizzes".concat(_HeaderMenuButton.displayName)), _defineProperty(_HeaderMenuButton, "propTypes", {
  sidebarMenuClick: PropTypes.func.isRequired,
  hidden: PropTypes.bool.isRequired,
  sidebarOpen: PropTypes.bool.isRequired,
  screenreaderNotification: PropTypes.func.isRequired,
  styles: PropTypes.object
}), _HeaderMenuButton)) || _class);
export default HeaderMenuButton;